import React from "react";

type Props = { value: unknown };

export default function MiscJsonCell({ value }: Props) {
  if (value == null || value === "") return <>—</>;
  let pretty: string;
  if (typeof value === "string") {
    try {
      pretty = JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      pretty = value;
    }
  } else {
    pretty = JSON.stringify(value, null, 2);
  }
  return (
    <details>
      <summary style={{ cursor: "pointer", color: "#3b82f6" }}>{"{…}"}</summary>
      <pre style={{ whiteSpace: "pre-wrap", fontSize: 12, margin: 0 }}>{pretty}</pre>
    </details>
  );
}
